var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMagnifyingGlass = function SvgIconMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.875 2a8.875 8.875 0 1 0 5.529 15.818l3.889 3.89a1 1 0 0 0 1.414-1.415l-3.89-3.89A8.875 8.875 0 0 0 10.875 2M4 10.875a6.875 6.875 0 1 1 13.75 0 6.875 6.875 0 0 1-13.75 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconMagnifyingGlass;